import { render, staticRenderFns } from "./StartDays.vue?vue&type=template&id=2bcd0d61&scoped=true&"
import script from "./StartDays.vue?vue&type=script&lang=js&"
export * from "./StartDays.vue?vue&type=script&lang=js&"
import style0 from "./StartDays.vue?vue&type=style&index=0&id=2bcd0d61&lang=scss&scoped=true&"
import style1 from "./StartDays.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd0d61",
  null
  
)

export default component.exports